import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import Bouton from '../../../UI/Bouton/Bouton';
import ImporterImage from '../../../UI/ImporterImage/ImporterImage';

import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as actions from '../../../../services/actions';

const AjouterImageTypeCapteur = ({ sensor_type_id }) => {
  // State management
  const [importedImage, setImportedImage] = useState(null);

  const dispatch = useDispatch();

  // Handle image import
  const handleImageImport = useCallback((imageData) => {
    setImportedImage(imageData);
  }, []);

  // Handle image upload
  const handleImageUpload = useCallback(() => {
    if (!importedImage) return;

    dispatch(
      actions.reqAjouterImageTypeDeCapteur(sensor_type_id, importedImage.base64)
    );
  }, [dispatch, sensor_type_id, importedImage]);

  // Cleanup effect
  useEffect(() => {
    return () => {
      // Cleanup any resources if needed
      setImportedImage(null);
    };
  }, []);

  return (
    <div>
      <ImporterImage
        extensionAccepter={'.svg'}
        gererImageImporter={handleImageImport}
      />
      <AttenteRequete
        request_type={requestType.ajouter_une_image_de_type_de_capteur}
      >
        <Bouton cliquer={handleImageUpload} desactive={!importedImage}>
          {checkMot('enregistrer_l_image')}
        </Bouton>
      </AttenteRequete>
    </div>
  );
};

export default AjouterImageTypeCapteur;
